import React from 'react';

const Testimonials = () => {
    const reviews = [
        {
            id: 1,
            name: "Alex Jensen",
            role: "CEO, FitPulse",
            quote: "Top Orion transformed our trainer platform. The MERN architecture handles 10k users seamlessly.",
            result: "200% Revenue Growth"
        },
        {
            id: 2,
            name: "Sarah Connors",
            role: "CTO, Nebula",
            quote: "Cleanest code we've seen. Delivered the project 2 weeks early. Highly recommended for React work.",
            result: "Shipped Early"
        },
        {
            id: 3,
            name: "David Chen",
            role: "Founder, Apex",
            quote: "We needed a complex Stripe integration. Salman nailed it. Our conversion rate went up 40%.",
            result: "+40% Conversion"
        },
        {
            id: 4,
            name: "Emily Davis",
            role: "Product Lead",
            quote: "Incredible attention to UI details. The dashboard feels like a native app. True engineering excellence.",
            result: "Native Feel"
        },
        {
            id: 5,
            name: "Mark T.",
            role: "Director",
            quote: "A developer who actually understands business logic. The admin panel saved us 20 hours a week.",
            result: "20hrs Saved/Week"
        },
        {
            id: 6,
            name: "Lisa Wong",
            role: "Startup Founder",
            quote: "From MVP to Scale in 3 months. Top Orion is the partner you want for the long haul.",
            result: "Successful Exit"
        }
    ];

    // Card Component
    const ReviewCard = ({ review }) => (
        <div className="bg-surface/50 p-6 rounded-xl border border-white/5 backdrop-blur-sm hover:border-neon-blue/40 transition-colors mb-6 break-inside-avoid">
            <div className="flex items-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="text-xs font-mono text-green-500 uppercase tracking-wider">{review.result}</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">"{review.quote}"</p>
            <div className="border-t border-white/5 pt-4">
                <p className="text-white font-bold text-sm">{review.name}</p>
                <p className="text-gray-500 text-xs">{review.role}</p>
            </div>
        </div>
    );

    return (
        <section className="bg-void py-24 relative overflow-hidden">
            <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                
                {/* LEFT: Sticky Header */}
                <div className="relative z-10">
                    <span className="text-neon-blue font-mono text-sm tracking-widest uppercase mb-4 block">
                        // Continuous Feedback
                    </span>
                    <h2 className="text-4xl md:text-6xl font-black text-white font-display mb-6">
                        CLIENT <br /> SIGNALS
                    </h2>
                    <p className="text-gray-400 text-lg max-w-md mb-8">
                        We don't just write code; we build relationships. See what happens when engineering meets business strategy.
                    </p>
                    <div className="flex items-center gap-4">
                        <div className="text-3xl font-bold text-white">100%</div>
                        <div className="text-sm text-gray-500 uppercase tracking-widest">
                            Job Success <br /> Score
                        </div>
                    </div>
                </div>

                {/* RIGHT: The Vertical Parallax Feed */}
                {/* We create a mask so it fades out at top and bottom */}
                <div className="relative h-[600px] overflow-hidden [mask-image:linear-gradient(to_bottom,transparent,black_10%,black_90%,transparent)]">
                    
                    <div className="grid grid-cols-2 gap-6">
                        
                        {/* Column 1: Moves Up */}
                        <div className="animate-scroll-up">
                            {/* Duplicate array for infinite loop */}
                            {[...reviews, ...reviews].map((review, idx) => (
                                <ReviewCard key={`col1-${idx}`} review={review} />
                            ))}
                        </div>

                        {/* Column 2: Moves Down (Offset slightly) */}
                        <div className="animate-scroll-down pt-24">
                            {[...reviews, ...reviews].map((review, idx) => (
                                <ReviewCard key={`col2-${idx}`} review={review} />
                            ))}
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default Testimonials;